import * as msal from '@azure/msal-browser';
import store from '../store';
import biboClient from './biboClient';
import configs from '../configs';

const msalAuth = (function() {
  const msalConfig = {
    auth: {
      clientId: 'f21a7f8a-31ca-428a-af80-a297ddd68df1',
      authority:
        'https://login.microsoftonline.com/5fe9dbda-6ad3-4988-b970-d9ddd3928ff2',
      redirectUri: configs.redirectUri,
    },
    cache: {
      cacheLocation: 'localStorage', // This configures where your cache will be stored
      storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
      loggerOptions: {
        loggerCallback: (level, message, containsPii) => {
          if (containsPii) {
            return;
          }
          switch (level) {
            case msal.LogLevel.Error:
              // eslint-disable-next-line no-console
              console.error(message);
              return;
            case msal.LogLevel.Info:
              // eslint-disable-next-line no-console
              console.info(message);
              return;
            case msal.LogLevel.Verbose:
              // eslint-disable-next-line no-console
              console.debug(message);
              return;
            case msal.LogLevel.Warning:
              // eslint-disable-next-line no-console
              console.warn(message);
              return;
          }
        },
      },
    },
  };

  const loginRequest = {
    scopes: ['api://669fda8a-557e-45a0-a425-5c87408c756e/bo.access'],
    prompt: 'select_account',
  };

  function selectAccount() {
    const currentAccounts = msalInstance.getAllAccounts();
    if (currentAccounts.length === 0) {
      return;
    } else if (currentAccounts.length > 1) {
      // eslint-disable-next-line no-console
      console.warn('Multiple accounts detected.');
      let authenticatedAccount = msalInstance.getActiveAccount();
      authenticatedUser = authenticatedAccount.username;
    } else if (currentAccounts.length === 1) {
      authenticatedUser = currentAccounts[0].username;
    }
  }

  function handleResponse(response) {
    if (response !== null) {
      authenticatedUser = response.account.username;
      store.commit('updateToken', {
        accessToken: response.accessToken,
        expiresOn: response.expiresOn,
      });
      const client = biboClient.create();
      client.get('/api/identity').then(resp => {
        const identity = resp.data;
        identity.isAuthenticated = true;
        store.commit('updateUser', identity);
      });

      msalInstance.setActiveAccount(response.account);
    } else {
      selectAccount();
    }
  }

  let authenticatedUser = '';

  const tokenRequest = {
    scopes: ['api://669fda8a-557e-45a0-a425-5c87408c756e/bo.access'],
    forceRefresh: false, // Set this to "true" to skip a cached token and go to the server to get a new token
  };

  const msalInstance = new msal.PublicClientApplication(msalConfig);

  function getAuthenticatedUser() {
    selectAccount();
    return authenticatedUser;
  }

  function signIn() {
    return msalInstance
      .loginPopup(loginRequest)
      .then(handleResponse)
      .catch(error => {
        // eslint-disable-next-line no-console
        console.error(error);
      });
  }

  function signOut() {
    const logoutRequest = {
      account: msalInstance.getAccountByUsername(authenticatedUser),
      postLogoutRedirectUri: msalConfig.auth.redirectUri,
      mainWindowRedirectUri: msalConfig.auth.redirectUri,
    };

    msalInstance.logoutPopup(logoutRequest);
  }

  function getTokenPopup() {
    const username = authenticatedUser;
    tokenRequest.account = msalInstance.getAccountByUsername(username);
    return msalInstance
      .acquireTokenSilent(tokenRequest)
      .then(handleResponse)
      .catch(error => {
        // eslint-disable-next-line no-console
        console.warn(
          'silent token acquisition fails. acquiring token using popup'
        );
        if (error instanceof msal.InteractionRequiredAuthError) {
          // fallback to interaction when silent call fails
          return msalInstance
            .acquireTokenPopup(tokenRequest)
            .then(tokenResponse => {
              return tokenResponse;
            })
            .catch(error => {
              // eslint-disable-next-line no-console
              console.error(error);
            });
        } else {
          // eslint-disable-next-line no-console
          console.warn(error);
        }
      });
  }

  return {
    getAuthenticatedUser: () => getAuthenticatedUser(),
    tokenRequest,
    msalInstance,
    signIn: () => signIn(),
    signOut: () => signOut(),
    getTokenPopup: () => getTokenPopup(),
  };
})();

export default msalAuth;
